var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5afcc057b2c6baef2fb950f1e9b8f065089a2ef1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["lifeworkcalendar@reclaimai"]={id:"5afcc057b2c6baef2fb950f1e9b8f065089a2ef1"};
      